module.exports = __webpack_public_path__ + "img/12.4a4b81f7.jpg";